import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  tickets: defineResolver<QuoteSparseTicketInput[]>(({resolveField, resolveStoreProp}) => ({
    resolve: () => {
      const selectedTickets = resolveStoreProp('tickets', 'selectedTickets')
      const perGuestQuestionAnswers = resolveField('perGuestQuestionAnswers')

      if (!perGuestQuestionAnswers || perGuestQuestionAnswers.size === 0) {
        return selectedTickets
      }

      selectedTickets.forEach(ticket => {
        ticket.questionAnswers = perGuestQuestionAnswers.get(ticket.refid) ?? []
      })

      return selectedTickets
    },
    traits: {
      withNonMandatoryQuestionAnswers: () => {
        const selectedTickets = resolveStoreProp('tickets', 'selectedTickets')
        const nonMandatoryPerGuestAnswers = resolveField('perGuestQuestionAnswers', ['nonMandatory'])

        if (!nonMandatoryPerGuestAnswers || nonMandatoryPerGuestAnswers.size === 0) {
          return selectedTickets
        }

        selectedTickets.forEach(ticket => {
          ticket.questionAnswers = nonMandatoryPerGuestAnswers.get(ticket.refid) ?? []
        })

        return selectedTickets
      }
    }
  }))
}
